import { NotificationType } from '@naturehouse/design-system/components/atoms/notification/Notification';
import { StatusPanelVariant } from '@naturehouse/design-system/components/molecules/status-panel/StatusPanel';
import statusPanelTemplate from '@naturehouse/design-system/components/molecules/status-panel/StatusPanel.html.njk';
import HttpClient from '@naturehouse/design-system/js/utils/HttpClient';
import InitializationError from '@naturehouse/nh-essentials/lib/exceptions/InitializationError';
import HttpError from '@naturehouse/nh-essentials/lib/requests/HttpError';
import createNotification from '../../../util/notification';
import ModalComponent from '../../shared/components/ModalComponent';
import '../../../../css/components/rejectBookingModal.pcss';

export default class RejectBookingComponent extends ModalComponent {
    #notificationElement: HTMLElement = this.modalElement?.querySelector(
        '[data-role="notification"]'
    ) as HTMLElement;

    #submitButton = this.modalElement?.querySelector('button[type="submit"]') as HTMLButtonElement;

    protected onModalOpened(): void {
        this.#notificationElement = this.modalElement?.querySelector(
            '[data-role="notification"]'
        ) as HTMLElement;

        this.#submitButton = this.modalElement?.querySelector(
            'button[type="submit"]'
        ) as HTMLButtonElement;

        const form = this.modalElement?.querySelector('form');
        if (!this.#notificationElement || !this.modalElement || !this.#submitButton || !form) {
            throw new InitializationError();
        }

        this.setEventListeners(form);
    }

    protected onSuccess(): void {
        super.onSuccess();
        this.submitButtonIconToggle(this.#submitButton);

        this.closeDialog();

        createNotification(NotificationType.SUCCESS, this.context.bindings.successMessage);

        const tableRow = this.context.element.closest('tr');

        if (!tableRow) {
            setTimeout(() => {
                window.location.reload();
            }, 500);
            return;
        }

        tableRow.remove();
    }

    private setEventListeners(form: HTMLFormElement): void {
        form.addEventListener('change', () => {
            this.#submitButton?.removeAttribute('disabled');
        });

        this.#submitButton?.addEventListener('click', async () => {
            this.#clearErrorMessage(this.#notificationElement);

            this.#submitButton.disabled = true;
            this.submitButtonIconToggle(this.#submitButton);

            const formData = new FormData(form);
            const data = HttpClient.convertFormDataToQueryString(formData);

            try {
                const response = await HttpClient.post(this.context.bindings.endpoint, data);

                if (response instanceof HttpError) {
                    throw new Error(response.message);
                }

                this.onSuccess();
            } catch (error: any) {
                this.onFailure();
                this.#setErrorNotification(error.message, this.#notificationElement);
            }
        });
    }

    #clearErrorMessage(notificationElement: HTMLElement): void {
        notificationElement.innerHTML = '';
    }

    #setErrorNotification(message: string, notificationElement: HTMLElement): void {
        notificationElement.innerHTML = statusPanelTemplate.render({
            variant: StatusPanelVariant.warning,
            label: message
        });
    }

    protected onFailure(): void {
        this.submitButtonIconToggle(this.#submitButton);
        this.#submitButton.disabled = false;
    }

    static getClassName(): string {
        return 'RejectBookingComponent';
    }
}
